(function initLogoScroller() {
    const wrap = document.querySelector('.logo-carousel-wrap');
    if (!wrap) return;

    const container = wrap.querySelector('.logo-carousel'); // scroll container
    const prevBtn = wrap.querySelector('.swiper-button-prev');
    const nextBtn = wrap.querySelector('.swiper-button-next');

    // Scroll by ~80% of visible width
    const step = () => Math.max(80, Math.round(container.clientWidth * 0.8));

    const hasOverflow = () => container.scrollWidth > container.clientWidth + 1;
    const atStart = () => container.scrollLeft <= 0;
    const atEnd = () =>
        container.scrollLeft >= (container.scrollWidth - container.clientWidth - 1);

    function updateNav() {
        const overflow = hasOverflow();

        // Drive styles:
        wrap.classList.toggle('is-locked', !overflow);
        container.classList.toggle('has-overflow', overflow);
        container.classList.toggle('no-overflow', !overflow);

        const setBtn = (btn, disabled) => {
            if (!btn) return;
            btn.classList.toggle('is-disabled', disabled);
            btn.setAttribute('aria-hidden', disabled ? 'true' : 'false');
            btn.tabIndex = disabled ? -1 : 0;
        };

        if (!overflow) {
            setBtn(prevBtn, true);
            setBtn(nextBtn, true);
            return;
        }

        setBtn(prevBtn, atStart());
        setBtn(nextBtn, atEnd());
    }

    function scrollLeft() { container.scrollBy({ left: -step(), behavior: 'smooth' }); }
    function scrollRight() { container.scrollBy({ left: step(), behavior: 'smooth' }); }

    prevBtn && prevBtn.addEventListener('click', scrollLeft);
    nextBtn && nextBtn.addEventListener('click', scrollRight);

    container.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    window.addEventListener('load', updateNav);

    // Recalc after images load
    const imgs = container.querySelectorAll('img');
    let pending = imgs.length;
    if (pending === 0) updateNav();
    imgs.forEach(img => {
        if (img.complete) {
            if (--pending === 0) updateNav();
        } else {
            const done = () => { if (--pending === 0) updateNav(); };
            img.addEventListener('load', done);
            img.addEventListener('error', done);
        }
    });

    // Optional keyboard support
    wrap.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); scrollLeft(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); scrollRight(); }
    });

    updateNav();
})();
